export const UPDATE_OLYMPUS_LEAD_DATA = 'UPDATE_OLYMPUS_LEAD_DATA'
export const UPDATE_OLYMPUS_LEAD_DATA_CANCEL = 'UPDATE_OLYMPUS_LEAD_DATA_CANCEL'
